/**
 * Legacy color theme system.
 * TODO: Remove and replace with contents of semantic-theme.tsx.
 * @deprecated
 */
import { useContext } from 'react';
import { black, gray20, gray85, green, white } from '@spotify-internal/encore-foundation';
import getColor from 'color';
import { ThemeContext } from 'styled-components';
/**
 * Legacy color theming constant. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */

export var colors = {
  primaryColor: 'primaryColor',
  primaryColorText: 'primaryColorText',
  primaryColorActive: 'primaryColorActive',
  primaryColorActiveText: 'primaryColorActiveText',
  primaryColorHover: 'primaryColorHover',
  primaryColorFocus: 'primaryColorFocus',
  primaryColorFocusText: 'primaryColorFocusText',
  primaryColorSelected: 'primaryColorSelected',
  primaryColorSelectedText: 'primaryColorSelectedText',
  primaryColorOutline: 'primaryColorOutline',
  primaryColorDisabledLight: 'primaryColorDisabledLight',
  primaryColorDisabledDark: 'primaryColorDisabledDark'
};
/**
 * Legacy color theming function. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */

export var getTextColor = function getTextColor(value) {
  var convertedHex = getColor(value);
  return convertedHex.isLight() ? black : white;
};
/**
 * Legacy color theming function. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */

var getFocusTextColor = function getFocusTextColor(value) {
  var convertedHex = getColor(value);
  return convertedHex.isLight() ? getColor('black').alpha(0.9).rgb().string() : getColor('white').alpha(0.8).rgb().string();
};
/**
 * Legacy color theming function. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */


export var getActiveTextColor = function getActiveTextColor(value) {
  var convertedHex = getColor(value);
  return convertedHex.isLight() ? getColor('black').alpha(0.5).rgb().string() : getColor('white').alpha(0.5).rgb().string();
};
/**
 * Legacy color theming function. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */

export function getHoverColor(color) {
  return getColor(color).mix(getColor('white'), 0.25).hex();
}
/**
 * Legacy color theming function. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */

export function getActiveColor(color) {
  return getColor(color).mix(getColor('black'), 0.3).hex();
}
/**
 * Legacy color theming function. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */

export function getSelectedColor(color) {
  return getColor(color).mix(getColor('black'), 0.52).hex();
}
/**
 * Legacy color theming type. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */

/**
 * Legacy color theme generator. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */
export var colorThemeGenerator = function colorThemeGenerator(_ref) {
  var primaryColor = _ref.primaryColor,
      primaryColorText = _ref.primaryColorText,
      primaryColorHover = _ref.primaryColorHover,
      primaryColorActive = _ref.primaryColorActive,
      primaryColorActiveText = _ref.primaryColorActiveText,
      primaryColorFocus = _ref.primaryColorFocus,
      primaryColorFocusText = _ref.primaryColorFocusText,
      primaryColorOutline = _ref.primaryColorOutline,
      primaryColorSelected = _ref.primaryColorSelected,
      primaryColorSelectedText = _ref.primaryColorSelectedText,
      primaryColorDisabledLight = _ref.primaryColorDisabledLight,
      primaryColorDisabledDark = _ref.primaryColorDisabledDark;

  if (!primaryColor) {
    return {};
  }

  return {
    colors: {
      primaryColor: primaryColor,
      primaryColorText: primaryColorText || getTextColor(primaryColor),
      primaryColorHover: primaryColorHover || getHoverColor(primaryColor),
      primaryColorActive: primaryColorActive || getActiveColor(primaryColor),
      primaryColorActiveText: primaryColorActiveText || getActiveTextColor(primaryColor),
      primaryColorFocus: primaryColorFocus || getColor(primaryColor).mix(getColor('black'), 0.15).hex(),
      primaryColorFocusText: primaryColorFocusText || getFocusTextColor(primaryColor),
      primaryColorOutline: primaryColorOutline || getColor(primaryColor).alpha(0.2).rgb().string(),
      primaryColorSelected: primaryColorSelected || getSelectedColor(primaryColor),
      primaryColorSelectedText: primaryColorSelectedText || white,
      primaryColorDisabledLight: primaryColorDisabledLight || getColor(primaryColor).mix(getColor(gray85), 0.8).hex(),
      primaryColorDisabledDark: primaryColorDisabledDark || getColor(primaryColor).mix(getColor(gray20), 0.8).hex()
    }
  };
};

/**
 * Legacy color theming function. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */
export var getColorOrDefault = function getColorOrDefault(theme, color, defaultColor) {
  return theme && theme.colors && theme.colors[color] || defaultColor;
};
/* Export hook for theme usage outside of styled-components */

/**
 * Legacy color theming function. Can no longer be used with Encore Web components.
 * Will be removed in an upcoming release. Please migrate to the semantic color theming system.
 * @deprecated
 */

export var usePrimaryColor = function usePrimaryColor() {
  var defaultColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : green;
  var themeContext = useContext(ThemeContext);
  return themeContext && themeContext.colors && themeContext.colors.primaryColor || defaultColor;
};